import React from "react";

const Footer = ({ id = "contact" }) => {
  return (
    <footer className="lp-footer bg-mainTextColor text-white/60" id={id}>
      <div className="lp-footer-wrap">
        <div className="lp-footer-top">

          {/* Col 1 — Brand */}
          <div className="lp-footer-brand wow animate__animated animate__fadeInUp">
            <img src="assets/img/VBRSIT-logo.png" className="lp-footer-logo" alt="VBRS IT Solutions" />
            <p className="lp-footer-tagline">
              Smart HR for growing businesses.<br />Built by VBRS IT Solutions.
            </p>
          </div>

          {/* Col 2 — Contact */}
          <div className="lp-footer-col">
            <p className="lp-footer-col-title">Get In Touch</p>
            <ul className="lp-footer-contact-list">
              <li>
                <i className="ph ph-envelope-simple-open"></i>
                <a href="mailto:info@cubhrm.com" className="lp-footer-link">info@cubhrm.com</a>
              </li>
              <li>
                <i className="ph ph-phone-call"></i>
                <a href="tel:+1234579" className="lp-footer-link">+91 9705678967</a>
              </li>
              <li>
                <i className="ph ph-paper-plane-tilt"></i>
                <span>Sandhya Techno-1, 10th Floor, C9CM+MRR, X Road, Radhe Nagar, Khajaguda, Raidurg, Telangana – 500032</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="lp-footer-bottom">
          <p>Cub Hrm © Copyright {new Date().getFullYear()}. All Rights Reserved.</p>
          <div className="lp-footer-legal">
            <a href="/privacy-policy" className="lp-footer-link">Privacy Policy</a>
            {/* <a href=" " className="lp-footer-link">Terms & Conditions</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
